import React from 'react';

import { ParnDetails_odProtosListingsServicesPartneragentreferralnetwork_getPARNDetails_parnDetails as ParnDetails } from '../../graphql/athena/queries/__generated__/ParnDetails';
import { convertParnDetails } from '../../helpers/getAllParnLeadData';
import { ParnLeadCard } from './ParnLeadCard';

/**
 * storybook-check-ignore
 */
interface ParnLeadCardWrapperProps {
  parnDetails: ParnDetails;
  agentCustomerUuid: string;
}

/** Wrapper for a ParnLeadCard that does data fetching */
export const ParnLeadCardWrapper: React.FC<ParnLeadCardWrapperProps> = ({
  parnDetails,
  agentCustomerUuid,
}) => {
  const convertedParnLeadDetails = convertParnDetails(parnDetails);

  if (!convertedParnLeadDetails) {
    return <div>No leads available.</div>;
  }
  const { parnData, customerData } = convertedParnLeadDetails;

  return (
    <ParnLeadCard
      key={parnData.token}
      name={customerData?.name}
      agentLead={convertedParnLeadDetails}
      agentCustomerUuid={agentCustomerUuid}
    />
  );
};
